module.exports = __webpack_public_path__ + "static/media/essencial-s920.94d033cd.png";